export default __webpack_public_path__ + "static/media/A10pro.41258c84.png";